<template>
  <div class="pb-4">
    <h3
      id="modal-headline"
      class="py-2 text-lg leading-6 font-medium text-gray-900"
    >
      Add a Warranty
    </h3>
    <div class="py-2">
      <div v-if="step == 'choose-warranty'" class="flex flex-col space-y-4">
        <div class="flex items-center space-x-4">
          <span>Total warrantable value: </span>
          <LoadingSpinner
            v-if="loadingWarrantableValue"
            class="text-green-600"
          />
          <span v-else>{{ warrantableValue | currency }}</span>
        </div>
        <p class="text-sm leading-5 text-gray-500">
          Please select the desired warranty
        </p>
        <div class="flex justify-around">
          <Button
            v-for="(warranty, index) in filteredWarranties"
            :key="index"
            v-on:click-handler="setWarranty(warranty)"
            :disabled="loadingWarrantableValue || !warrantableValue"
          >
            {{ warranty.name }}
          </Button>
        </div>

        <HttpError :error="error" />

        <div class="pt-4 flex justify-end">
          <Button
            v-on:click-handler="$emit('onClose', true)"
            class="btn btn-white"
          >
            Cancel
          </Button>
        </div>
      </div>

      <div v-if="step == 'confirm-warranty'" class="flex flex-col space-y-4">
        <div class="flex items-center space-x-4">
          <span>Total warrantable value: </span>
          <span>{{ warrantableValue | currency }}</span>
        </div>
        <div class="flex items-center space-x-4">
          <span>Warranty value: </span>
          <span>{{ (warrantableValue * warranty.value) | currency }}</span>
          <span class="italic">( {{ warranty.name }} )</span>
          <span v-on:click="restartFlow()">
            <icon name="x" class="w-4 h-4 text-red-300 cursor-pointer" />
          </span>
        </div>
        <HttpError :error="error" />
        <div class="flex space-x-4 justify-end">
          <Button
            v-on:click-handler="$emit('onClose', true)"
            class="btn btn-white"
          >
            Cancel
          </Button>
          <Button
            v-on:click-handler="createWarranty()"
            :disabled="saving"
            class="flex items-center space-x-2"
          >
            <LoadingSpinner v-if="saving" />
            <span>Confirm</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import moneyFormatter from "@/mixins/moneyFormatter";
import Button from "@/components/elements/Button.vue";
import auth from "@/api/auth";

const OrdersApi = ApiFactory.get("orders");

export default {
  name: "AddWarranty",
  components: {
    Button,
  },
  filters: {
    currency: moneyFormatter.format,
  },
  data() {
    return {
      step: "choose-warranty",
      warranties: [
        {
          type: "basic",
          value: 0.1,
          name: "10% Warranty",
        },
        {
          type: "extended",
          value: 0.25,
          name: "25% Extended Warranty",
        },
        {
          type: "free",
          value: 0.0,
          name: "Free Warranty",
        },
      ],
      warranty: {},
      warrantableValue: null,
      loadingWarrantableValue: true,
      saving: false,
      error: null,
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
    filteredWarranties() {
      return this.warranties.filter((warranty) => {
        if (
          warranty.type.toLowerCase() !== "free" ||
          (warranty.type.toLowerCase() === "free" &&
            this.userCanGiveFreeWarranty)
        ) {
          return true;
        }
      });
    },
    userCanGiveFreeWarranty() {
      return auth.isUserAuthorized(["supervisor", "admin"]);
    },
  },
  created() {
    this.setWarrantableValue();
  },
  methods: {
    setWarranty(warranty) {
      this.warranty = warranty;
      this.step = "confirm-warranty";
    },
    restartFlow() {
      this.warranty = {};
      this.step = "choose-warranty";
    },
    setWarrantableValue() {
      this.loadingWarrantableValue = true;
      this.error = null;
      OrdersApi.getWarrantableValue(this.order.SourceOrderNumber)
        .then((response) => (this.warrantableValue = response.data.body))
        .catch((e) => (this.error = e))
        .finally(() => (this.loadingWarrantableValue = false));
    },
    createWarranty() {
      this.saving = true;
      OrdersApi.createWarranty(this.order.SourceOrderNumber, {
        type: this.warranty.type,
      })
        .then(() => {
          this.saving = false;
          this.reloadRelatedInformation();
          this.$emit("onClose", true);
        })
        .catch((e) => (this.error = e));
    },
    reloadRelatedInformation() {
      this.$store.dispatch("orders/refreshOrder", this.order.SourceOrderNumber);
    },
  },
};
</script>
